import {Component} from '@angular/core';
import {InfoModalComponent} from "../info_modal.component";
import * as moment from 'moment-timezone';
import { getSiteStatusStyle, mergeFilterParams } from "app/lib/lib";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import { BillingService2 } from "../../../billing/billing.service";


@Component({
	templateUrl: './paid_details.component.html'
})
export class PaidDetailsComponent extends InfoModalComponent {
	public moment = moment;
	public getSiteStatusStyle = getSiteStatusStyle;
	
	public currentPage;
	public params;
	public groupDate;
	public divide;
	public details;
	detailLoader: boolean = false;
	totalCount = 0;

	constructor(
		public activeModal: NgbActiveModal,
		private billingService: BillingService2
	) {
		super(activeModal);
	}

	ok() {
		this.close();
	}

	async onPageChange() {
		if (!this.currentPage) return true;
		
		this.detailLoader = true;
		const { stats } = await this.billingService.siteBilling.detail(
			mergeFilterParams(
				this.params,
				{
					dateTime: this.groupDate,
					page: this.currentPage,
					divide: this.divide
				}
			)
		).toPromise();
		this.details = stats;
		this.detailLoader = false;
	}
}
